import React from 'react';
import ModuleRoute from 'holocron-module-route';
import AuthenticationWrapper from './components/AuthenticationWrapper';
import ErrorPage from './components/DefaultErrorPage';
import LogoutHandler from './components/LogoutHandler';
import RedirectToLocaleRoute from './components/RedirectToLocaleRoute';
import updateLocaleFromRoute from './updateLocaleFromRoute';
import loadProductData from './loadProductData';
import { endClientSessionHook } from './endClientSession';
import { loginEndSessionEntryPoint } from './loginEndSessionEntryPoint';
import ChangePasswordWrapper from './components/ChangePasswordWrapper';
import TwoStepManageWrapper from './components/TwoStepManageWrapper';
import IdentityManagementCenterWrapper from './components/IdentityManagementCenterWrapper';
import ProfileRefreshWrapper from './components/ProfileRefreshWrapper';
import TwoStepVerificationWrapper from './components/TwoStepVerificationWrapper';
import PasskeysWrapper from './components/PasskeysWrapper';
import { showFdicBanner } from './showFdicBanner';
import RsvpVerification from './components/RsvpVerification';
import { Dls6Wrapper, Dls7Wrapper } from './components/DlsWrapper';

const childRoutes = (store) => [
  <ModuleRoute path="demo/:moduleName" moduleName="axp-demo" key="axp-demo" />,
  <ModuleRoute key="start" path="start" moduleName="axp-dev-start" />,
  <ModuleRoute key="dash" path="dash" moduleName="axp-dash-container" />,
  <ModuleRoute key="one-identity" name="one-identity" moduleName="one-identity-universal-session-manager">
    <ModuleRoute path="account">
      <ModuleRoute component={Dls6Wrapper}>
        <ModuleRoute path="rsvp/verification/:rsvpCode" component={RsvpVerification} />
        <ModuleRoute path="oauth(/:type)" title="Enrollment" moduleName="one-identity-oauth" />
      </ModuleRoute>
      <ModuleRoute component={Dls6Wrapper}>
        <ModuleRoute component={RedirectToLocaleRoute}>
          <ModuleRoute path="login" title="Login" moduleName="one-identity-login-page" />
          <ModuleRoute path="logout" title="Logout" />
        </ModuleRoute>
      </ModuleRoute>
    </ModuleRoute>
    <ModuleRoute path=":locale/account" onEnter={updateLocaleFromRoute(store)}>
      <ModuleRoute path="profile">
        <ModuleRoute component={AuthenticationWrapper}>
          <ModuleRoute component={Dls7Wrapper}>
            <ModuleRoute
              path="smart"
              name="identity-ui-smart-profile"
              moduleName="identity-ui-smart-profile"
              title="Profile Management"
              key="smart-profile"
            />
          </ModuleRoute>
        </ModuleRoute>
      </ModuleRoute>
    </ModuleRoute>
    <ModuleRoute path="account">
      <ModuleRoute moduleName="axp-page-wrapper">
        <ModuleRoute component={Dls6Wrapper}>
          <ModuleRoute path="third-party/authenticate(/:returnRoute)" title="Third Party" moduleName="one-identity-third-party" authenticationType="oidc" />
          <ModuleRoute path="tp/authenticate(/:returnRoute)" title="Third Party" moduleName="one-identity-third-party" authenticationType="oidc" />
        </ModuleRoute>
      </ModuleRoute>
    </ModuleRoute>
    <ModuleRoute component={Dls6Wrapper}>
      <ModuleRoute path="account/third-party/connect(/:returnRoute)" title="Third Party" moduleName="one-identity-third-party" authenticationType="fsso" />
    </ModuleRoute>
    <ModuleRoute path=":locale/account" onEnter={updateLocaleFromRoute(store)}>
      <ModuleRoute path="logout" title="Logout" onEnter={endClientSessionHook(store)} disableSession={true} component={LogoutHandler} />
      <ModuleRoute component={Dls6Wrapper}>
        <ModuleRoute
          path=":content/login"
          title="Login"
          onEnter={loginEndSessionEntryPoint(store)}
          disableSession={true}
          moduleName="one-identity-login-page"
        />
      </ModuleRoute>
      <ModuleRoute component={Dls7Wrapper}>
        <ModuleRoute path="integrated">
          <ModuleRoute path="authenticate" onEnter={loadProductData(store)} title="Authentication" moduleName="one-identity-authentication-container" />
          <ModuleRoute component={Dls7Wrapper}>
            <ModuleRoute
              path="load-experience"
              name="identity-ui-create"
              moduleName="identity-ui-create"
              title="Identity UI"
              key="load-experience"
            />
          </ModuleRoute>
        </ModuleRoute>
      </ModuleRoute>
      <ModuleRoute component={Dls6Wrapper}>
        <ModuleRoute moduleName="identity-ui-page-wrapper" showFdic={showFdicBanner(store)}>
          <ModuleRoute path="login" title="Login" onEnter={loginEndSessionEntryPoint(store)} disableSession={true} moduleName="one-identity-login-page" />
        </ModuleRoute>
      </ModuleRoute>
      <ModuleRoute moduleName="axp-page-wrapper">
        <ModuleRoute component={Dls7Wrapper}>
          <ModuleRoute component={AuthenticationWrapper}>
            <ModuleRoute path="passkeys/manage" title="Passkeys Registration" component={PasskeysWrapper} onEnter={loadProductData(store)} />
          </ModuleRoute>
        </ModuleRoute>
        <ModuleRoute component={Dls7Wrapper}>
          <ModuleRoute component={AuthenticationWrapper}>
            <ModuleRoute path="manage/killswitch" title="Login Kill Switch" moduleName="identity-ui-identity-lockout" />
          </ModuleRoute>
        </ModuleRoute>
        <ModuleRoute component={Dls7Wrapper}>
          <ModuleRoute component={AuthenticationWrapper}>
            <ModuleRoute path="authenticator/register" title="Register" moduleName="one-identity-authenticator-registration" />
          </ModuleRoute>
        </ModuleRoute>
        <ModuleRoute component={Dls7Wrapper}>
          <ModuleRoute path="authentication/:appId/:actionId(/:token)" title="Authentication" moduleName="one-identity-authentication-container" />
        </ModuleRoute>
        <ModuleRoute path="profile">
          <ModuleRoute component={AuthenticationWrapper}>
            <ModuleRoute component={Dls7Wrapper}>
              <ModuleRoute
                path="smart"
                name="identity-ui-smart-profile"
                moduleName="identity-ui-smart-profile"
                title="Profile Management"
                key="smart-profile"
              />
            </ModuleRoute>
            <ModuleRoute component={Dls7Wrapper}>
              <ModuleRoute
                path="build"
                name="one-identity-profile-builder"
                moduleName="one-identity-profile-builder"
                title="Profile Builder"
                key="profile-builder"
              />
            </ModuleRoute>
            <ModuleRoute component={Dls6Wrapper}>
              <ModuleRoute
                path="share"
                name="one-identity-profile-sharer"
                moduleName="one-identity-profile-sharer"
                title="Profile Sharer"
                key="profile-sharer"
              />
            </ModuleRoute>
            <ModuleRoute component={Dls7Wrapper}>
              <ModuleRoute
                path="make"
                name="identity-ui-instant-profile"
                moduleName="identity-ui-instant-profile"
                title="Instant Profile"
                key="instant-profile"
                onEnter={loadProductData(store)}
              />
            </ModuleRoute>
            <ModuleRoute component={Dls7Wrapper}>
              <ModuleRoute
                path="manage"
                component={IdentityManagementCenterWrapper}
                title="Profile Management Center"
                key="profile-management-center"
              />
            </ModuleRoute>
            <ModuleRoute component={Dls7Wrapper}>
              <ModuleRoute path="verify" name="one-identity-verification" moduleName="one-identity-verification" title="Profile Verification" />
            </ModuleRoute>
            <ModuleRoute component={Dls7Wrapper}>
              <ModuleRoute path="refresh" component={ProfileRefreshWrapper} title="Profile Refresh" key="profile-refresh" />
            </ModuleRoute>
          </ModuleRoute>
          <ModuleRoute component={Dls7Wrapper}>
            <ModuleRoute
              path="create"
              name="one-identity-create"
              moduleName="one-identity-create"
              title="One Identity Profile Creation"
              skip="verification"
              key="profile-creation"
            />
          </ModuleRoute>
          <ModuleRoute component={Dls7Wrapper}>
            <ModuleRoute
              path="createaccount-without-verification"
              name="one-identity-create"
              moduleName="one-identity-create"
              title="One Identity Profile Creation"
              key="profile-creation"
              skipCreateLandingPage={true}
              skip="createProfileOrLogin,governmentIdentity,verification"
            />
          </ModuleRoute>
          <ModuleRoute component={Dls7Wrapper}>
            <ModuleRoute
              path="create-account"
              name="one-identity-create"
              moduleName="one-identity-create"
              title="One Identity Profile Creation"
              key="profile-creation"
              skipCreateLandingPage={true}
              skip="createProfileOrLogin,governmentIdentity,verification"
            />
          </ModuleRoute>
          <ModuleRoute component={Dls7Wrapper}>
            <ModuleRoute
              path="create-profile"
              name="one-identity-create"
              moduleName="one-identity-create"
              title="One Identity Profile Creation"
              key="profile-creation"
              skipCreateLandingPage={true}
              skip="createProfileOrLogin,governmentIdentity,verification"
              isEmailCollision={true}
            />
          </ModuleRoute>
        </ModuleRoute>
        <ModuleRoute component={Dls7Wrapper}>
          <ModuleRoute path="authenticate" onEnter={loadProductData(store)} title="Authentication" moduleName="one-identity-authentication-container" />
        </ModuleRoute>
        <ModuleRoute component={Dls7Wrapper}>
          <ModuleRoute path="reauth/verify" title="Verification" component={TwoStepVerificationWrapper} type="reauth" />
        </ModuleRoute>
        <ModuleRoute path="two-step-verification">
          <ModuleRoute component={Dls7Wrapper}>
            <ModuleRoute path="verify" title="Verification" component={TwoStepVerificationWrapper} type="login" />
          </ModuleRoute>
          <ModuleRoute component={Dls6Wrapper}>
            <ModuleRoute path="learn-more" title="Verification" moduleName="one-identity-two-step-learn-more" />
          </ModuleRoute>
          <ModuleRoute component={Dls7Wrapper}>
            <ModuleRoute component={AuthenticationWrapper}>
              <ModuleRoute path="manage" onEnter={loadProductData(store)} title="Verification" component={TwoStepManageWrapper} />
              <ModuleRoute path="manage-devices" onEnter={loadProductData(store)} title="Verification" component={TwoStepManageWrapper} />
            </ModuleRoute>
          </ModuleRoute>
          <ModuleRoute component={Dls7Wrapper}>
            <ModuleRoute component={AuthenticationWrapper}>
              <ModuleRoute path="settings" title="Settings" moduleName="identity-ui-two-step-manage" isSettingsPage={true} />
            </ModuleRoute>
          </ModuleRoute>
        </ModuleRoute>
        <ModuleRoute path="password">
          <ModuleRoute component={Dls6Wrapper}>
            <ModuleRoute path="reset" component={ChangePasswordWrapper} title="Change Password" />
          </ModuleRoute>
          <ModuleRoute component={Dls6Wrapper}>
            <ModuleRoute path="change" component={ChangePasswordWrapper} title="Change Password" />
          </ModuleRoute>
          <ModuleRoute component={Dls6Wrapper}>
            <ModuleRoute component={AuthenticationWrapper}>
              <ModuleRoute path="manage" onEnter={loadProductData(store)} component={ChangePasswordWrapper} title="Change Password" />
            </ModuleRoute>
          </ModuleRoute>
        </ModuleRoute>
        <ModuleRoute component={Dls7Wrapper}>
          <ModuleRoute moduleName="one-identity-credential-recovery">
            <ModuleRoute path=":flow/recover" exact={true} title="Recover" onEnter={endClientSessionHook(store)} disableSession={true} />
            <ModuleRoute path=":flow/recover/:returnRoute" title="Recover" />
          </ModuleRoute>
        </ModuleRoute>
      </ModuleRoute>

      <ModuleRoute component={Dls7Wrapper}>
        <ModuleRoute
          path="load-experience"
          name="identity-ui-create"
          moduleName="identity-ui-create"
          title="Identity UI"
          key="load-experience"
        />
      </ModuleRoute>
      <ModuleRoute component={Dls7Wrapper}>
        <ModuleRoute
          path="demo"
          name="axp-task-flow-wrapper"
          moduleName="axp-task-flow-wrapper"
          title="AXP Task Flow"
          key="axp-task-flow-wrapper"
        />
      </ModuleRoute>

    </ModuleRoute>
  </ModuleRoute>,
  <ModuleRoute key="error-layout">
    <ModuleRoute component={Dls6Wrapper}>
      <ModuleRoute
        code="500"
        component={ErrorPage}
        path="*/error"
        title="Load Error"
        httpStatus={500}
      />
    </ModuleRoute>
    <ModuleRoute component={Dls6Wrapper}>
      <ModuleRoute
        code="400"
        component={ErrorPage}
        path="*"
        title="Page Not Found"
        httpStatus={400}
      />
    </ModuleRoute>
  </ModuleRoute>,
];

export default childRoutes;
